export class UnreachableCaseException extends Error {
  constructor(variable: never, message: string) {
    super(message);
    this.name = 'UnreachableCaseException';
  }
}
